import React, { useContext, useEffect } from "react";
import './style.css'
import Botao from "../../components/Botao/Botao";
import Footer from "../../components/Footer/Footer";
import { NavLink } from "react-router-dom";
import { CompraContext } from "../../context/CompraContext";
import Lottie from "lottie-react";
import json from '../../images/animation_lnypqqsr.json'
import { PatchNegocio } from "../../services/crmService";
import { ObterProdutoExpress } from "../../data/crmProdutoExpress";
import { crmEstagioExpress } from "../../data/crmEstagioExpress";

function CompraFinalizada() {
    const { ProdutoCompra, transactionId, Cadastro } = useContext(CompraContext)

    useEffect(() => {
        try {
            window.dataLayer.push({
                event: 'venda_certificado', // nome do evento
                transaction_id: transactionId, // ID da transação 
                value: ProdutoCompra.anos[0].valor, // valor da compra 
                currency: 'BRL' // moeda
            });

        } catch (error) {
            console.log('Erro ao enviar dados para o Google Tag Manager')

            // não é o ideal, mas é a forma de encontrar algum erro caso o evento não seja enviado
            const negocioDto = {
                idEstagioVenda: crmEstagioExpress.NegocioPerdido, // negocio perdido
                pipeline: "PIPELINE_EXPRESS",
                produto: ObterProdutoExpress(Number(ProdutoCompra.anos[0].sku)),
                observacao: "Erro no envio do evento de compra para o Google Tag Manager",
            }
            PatchNegocio(negocioDto, Cadastro.email.trim())
        }
    }, []);


    return (
        <>
            <div className="compra-finalizada">
                <h2>Sua compra foi feita com sucesso!</h2>
                <div style={{ width: '100px', height: '100px', margin: '0 auto 30px auto' }}>
                    <Lottie animationData={json} loop={false} />
                </div>
                <p>Parabéns! Você acabou de adquirir o <b>{ProdutoCompra.resumo}</b>.</p>
                <p>Você receberá um e-mail com os passos para adquirir seu certificado.</p>
                <p>Qualquer dúvida entre em contato com <b>comercial@exactus.net.br</b></p>
                <NavLink to="/">
                    <Botao texto={'Voltar para a home'} />
                </NavLink>
            </div>
            <Footer footerCertificado={true} />
        </>
    )
}

export default CompraFinalizada